/**
 * Every competition-scoped cache entry is keyed by its `competitionId` — see
 * the comment on `competitionKeys` in `features/competitions/query-keys.ts`
 * for why that isn't optional.
 */
export const submissionKeys = {
  all: ['submissions'] as const,
  list: (competitionId: string, filters: Record<string, string> = {}) =>
    [...submissionKeys.all, competitionId, 'list', filters] as const,
  /** The caller's own team's submissions — `GET /submissions` with no admin filters. */
  mine: (competitionId: string) => [...submissionKeys.all, competitionId, 'mine'] as const,
  detail: (competitionId: string, submissionId: string) =>
    [...submissionKeys.all, competitionId, submissionId] as const,
  versions: (competitionId: string, submissionId: string) =>
    [...submissionKeys.detail(competitionId, submissionId), 'versions'] as const,
  receipts: (competitionId: string, submissionId: string) =>
    [...submissionKeys.detail(competitionId, submissionId), 'receipts'] as const,
}
